import ProductsCategorySlider from './ProductsCategorySlider';

export default ProductsCategorySlider;
